export default {"src":"/_next/static/media/helpIsHere.375499a0.svg","height":187,"width":360,"blurWidth":0,"blurHeight":0};